export default __webpack_public_path__ + "static/media/mac.3cdcf42e.svg";